// trims a character from the start or end of a string
// borrowed from https://stackoverflow.com/questions/26156292/trim-specific-character-from-a-string
export function trim(source, character) {
    var start = 0, 
        end = source.length;

    while(start < end && source[start] === character)
        ++start;

    while(end > start && source[end - 1] === character)
        --end;

    return (start > 0 || end < source.length) ? source.substring(start, end) : source;
}

